import React from 'react';

import ScreenWrapper from '../features/Theme/ScreenWrapper';
import LoginSessionIdForm from '../features/Authentication/LoginSessionIdForm';

export default function LoginSessionIdScreen() {
    return (
        <ScreenWrapper>
            <LoginSessionIdForm />
        </ScreenWrapper>
    );
}
